/* eslint-disable */
import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import React, { useMemo, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import Add from "views/admin/events/components/Add";
import AddReservationModal from "./AddReservationModal";
import { createReservationFull } from "Api/apiService";
import { deleteReservation } from "Api/apiService";
import DeleteModal from "./DeleteModal";

const toBlockTypeLabel = item =>
  String(item?.blockType || "").toLowerCase() === "time_range"
    ? "Time Range"
    : "Full Day";

const toTwelveHour = value => {
  const raw = String(value || "").trim();
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(raw);
  if (!match) {
    return raw;
  }
  const hour24 = Number(match[1]);
  const minute = Number(match[2]);
  const suffix = hour24 >= 12 ? "PM" : "AM";
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  return `${hour12}:${String(minute).padStart(2, "0")} ${suffix}`;
};

const toBlockWindowLabel = item => {
  const start = String(item?.startTime || "").trim();
  const end = String(item?.endTime || "").trim();
  return start && end ? `${toTwelveHour(start)} - ${toTwelveHour(end)}` : "All Day";
};

const toReasonLabel = item => {
  const raw = String(item?.reason || "").trim();
  if (!raw) {
    return "-";
  }
  const sanitized = raw.replace(/<[^>]*>/g, "").trim();
  return sanitized || "-";
};

const toDateOnlyLabel = value => {
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) {
    return "-";
  }
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
};

export default function ReservationTable(props) {
  const { columnsData, tableData, title, setSelectedOption, options } = props;
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReservationItem, setSelectedReservationItem] = useState(null);

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = 100;
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const handleReservationClick = (item) => {
    setSelectedReservationItem(item);
    setIsModalOpen(true);
  };
  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };
  const onDeleteEvent = async (reservationId) => {
    return deleteReservation(reservationId);
  };
  const updateReservationItem = async (reservationId, reservationDate) => {
    try {
      await updateReservationItem(reservationId, reservationDate);
    } catch (error) {
      console.error("Error updating menu status:", error);
    }
  };
  const closeModal = () => {
    setSelectedReservationItem(null);
    setIsModalOpen(false);
  };
  const onCreateReservationItem = async (payload) => {
    return createReservationFull(payload);
  };
  return (
    <Card direction="column" w="100%" px="0px">
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="26px"
          fontWeight="700"
          lineHeight="100%"
          textAlign="center"
          flex={1}
        >
          {title}
        </Text>
        <Box display="flex" alignItems="center">
          <Add onClick={() => setIsAddModalOpen(true)} />
          <Box width="16px" height="16px" />
          <Menu setSelectedOption={setSelectedOption} options={options} />
        </Box>
      </Flex>
      <Box
        overflowY="auto"
        maxHeight="750px"
        css={{
          "&::-webkit-scrollbar": {
            width: "5px",
          },
          "&::-webkit-scrollbar-track": {
            // background: "#f1f1f1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }}
      >
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    pe="10px"
                    key={index}
                    borderColor={borderColor}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      {column.render("Header")}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              const item = row.original;
              return (
                <Tr
                  {...row.getRowProps()}
                  key={index}
                  onClick={() => handleReservationClick(item)}
                  cursor="pointer"
                  _hover={bgHover}
                >
                  {row.cells.map((cell, index) => {
                    let data = "";

                    if (cell.column.Header === "DATE") {
                      const formattedDate = toDateOnlyLabel(cell.value);

                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {formattedDate}
                        </Text>
                      );
                    } else if (cell.column.Header === "BLOCK TYPE") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {toBlockTypeLabel(item)}
                        </Text>
                      );
                    } else if (cell.column.Header === "TIME WINDOW") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {toBlockWindowLabel(item)}
                        </Text>
                      );
                    } else if (cell.column.Header === "REASON") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="600">
                          {toReasonLabel(item)}
                        </Text>
                      );
                    }
                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "200px", lg: "auto" }}
                        borderColor="transparent"
                      >
                        {data}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>
      <AddReservationModal
        isOpen={isAddModalOpen}
        onClose={closeAddModal}
        onCreateReservationItem={onCreateReservationItem}
      />
      <DeleteModal
        isOpen={isModalOpen}
        onClose={closeModal}
        selectedReservationItem={selectedReservationItem}
        onDeleteEvent={onDeleteEvent}
      />
    </Card>
  );
}
